
import {Scene} from 'scene';

const Sprite = PIXI.Sprite;
const TextureCache = PIXI.utils.TextureCache;
const BitmapText = PIXI.extras.BitmapText;

const BET_EVENTS = {
    METEO: 0,
    SPORT: 1,
    NOPE: -1
};

export default class SceneEvents extends Scene {
    constructor(space) {
        super();

        const eventsBackground = new Sprite(TextureCache['res/events_screen.png']);
        this.addChild(eventsBackground);

        this.eventVariants = [
            new Sprite(TextureCache['res/meteo_event.png']),
            new Sprite(TextureCache['res/sport_event.png'])
        ];

        this.eventVariants.forEach(e => {
            this.addChild(e);
        });
        this.eventVariants[BET_EVENTS.METEO].position.set(707, 324);
        this.eventVariants[BET_EVENTS.SPORT].position.set(765, 158);
        this.eventVariants[BET_EVENTS.SPORT].scale.set(0.77, 0.77);
        this.eventVariants[BET_EVENTS.SPORT].alpha = 0.55;

        this.swapChildren(this.eventVariants[BET_EVENTS.METEO], this.eventVariants[BET_EVENTS.SPORT]);

        const eventUIPanel = new Sprite(TextureCache['res/choice_event_panel_ui.png']);
        eventUIPanel.position.set(0, 980);
        this.addChild(eventUIPanel);

        this.pointsLabel = new BitmapText("", {font: "points_font", align: "left"});
        this.pointsLabel.position.set(432, 40);
        eventUIPanel.addChild(this.pointsLabel);

        this.eventTerminalLabel = new BitmapText('', {font: "terminal_white_font", align: "left"});
        this.eventTerminalLabel.position.set(1390, 57);
        eventUIPanel.addChild(this.eventTerminalLabel);

        this.currentEvent = BET_EVENTS.METEO;

        this.eventVariants[BET_EVENTS.METEO].hitArea = new PIXI.Rectangle(127, 393, 252, 78);
        this.eventVariants[BET_EVENTS.METEO].pointerdown = event => {
            if (event.data.originalEvent.button != null && event.data.originalEvent.button != 0) {
                return;
            }
            space.s('eventSelected').next();
        };
        this.eventVariants[BET_EVENTS.METEO].interactive = true;

        const leftArrow = new PIXI.Graphics();
        leftArrow.hitArea = new PIXI.Rectangle(20, 488, 100, 182);
        leftArrow.pointerdown = event => {
            if (event.data.originalEvent.button != null && event.data.originalEvent.button != 0) {
                return;
            }
            this.swapEvents(false);
        };
        leftArrow.interactive = true;
        this.addChild(leftArrow)

        const rightArrow = new PIXI.Graphics();
        rightArrow.hitArea = new PIXI.Rectangle(1802, 488, 100, 182);
        rightArrow.pointerdown = event => {
            if (event.data.originalEvent.button != null && event.data.originalEvent.button != 0) {
                return;
            }
            this.swapEvents(true);
        };
        rightArrow.interactive = true;
        this.addChild(rightArrow);

    }

    //direction : true -> right, false-> left;
    swapEvents(direction) {

        if (this.currentEvent === BET_EVENTS.NOPE) {
            return;
        }

        let face = (this.currentEvent === BET_EVENTS.METEO) ? this.eventVariants[BET_EVENTS.METEO] : this.eventVariants[BET_EVENTS.SPORT];
        let back = (this.currentEvent === BET_EVENTS.METEO) ? this.eventVariants[BET_EVENTS.SPORT] : this.eventVariants[BET_EVENTS.METEO];

        let faceX = (direction) ? [1379, 765] : [140, 765];
        let backX = (direction) ? [140, 707] : [1379, 707];

        let nextEvent = (this.currentEvent === BET_EVENTS.METEO) ? BET_EVENTS.SPORT : BET_EVENTS.METEO;
        this.currentEvent = BET_EVENTS.NOPE;

        this.eventVariants[BET_EVENTS.METEO].interactive = false;

        let time = 500;

        let faceScaleTween = new TWEEN.Tween(face.scale)
            .to({x: 0.77, y: 0.77}, time)
            .start();

        let faceMoveTween = new TWEEN.Tween(face)
            .to({x: faceX, y : 158, alpha: 0.55}, time)
            .interpolation(TWEEN.Interpolation.CatmullRom)
            .start();

        let backScaleTween = new TWEEN.Tween(back.scale)
            .to({x: 1.0, y: 1.0}, time)
            .start();

        let backMoveTween = new TWEEN.Tween(back)
            .to({x: backX, y : 324, alpha : 1.0}, time)
            .interpolation(TWEEN.Interpolation.CatmullRom)
            .onComplete(() => {
                this.currentEvent = nextEvent;
                if (this.currentEvent === BET_EVENTS.METEO) {
                    this.eventVariants[BET_EVENTS.METEO].interactive = true;
                }
            })
            .start();

        setTimeout(() => {
            this.swapChildren(this.eventVariants[BET_EVENTS.METEO], this.eventVariants[BET_EVENTS.SPORT]);
        }, time/2);

    };

    canChoiceEvent() {
        return this.currentEvent === BET_EVENTS.METEO;
    };

    setBalance(balance) {
        this.pointsLabel.text = balance;
    }

    setTerminalId(id) {
        this.eventTerminalLabel.text = id
    }

}


// WEBPACK FOOTER //
// ./src/events_scene.es6